module.exports = __webpack_public_path__ + "static/media/MovieApp.f323b8e6.png";